export default __webpack_public_path__ + "static/media/xeNatus.adcb1ed4.png";